module.exports = __webpack_public_path__ + "media/cycles-gameplay@md-211e0657f27add280d851029c6593f93.gif";